import * as styles from "./SectionHelpAdviceNewsletterPromo.module.scss";

import { Button } from "../../../components/common";

import React from "react";
import FuzzyBorder from "../../../components/borders/FuzzyBorder";
import useWindowWidth from "../../../hooks/useWindowWidth";
import wagDogMobile from "../../../static/img/wag_dog.png";
import wagDogDesktop from "../../../static/img/wag_dog_desktop.png";
import wagDogDesktopIe from "../../../static/img/wag_dog_desktop_ie.png";
import wagDogMobileIe from "../../../static/img/wag_dog_ie.png";
import { Colours } from "../../../utils/colours";

export interface NewsLetterProps {
	title: string;
	body: string;
	buttonText: string;
	buttonUrl: string;
	jumpLinksTitle?: string;
}

const MobileNewsLetterPromo: React.FC<NewsLetterProps> = ({
	title,
	body,
	buttonText,
	buttonUrl,
	jumpLinksTitle,
}) => {
	return (
		<div className={styles.newslettermobile}>
			<div className={styles.newsletterpromoouter}>
				<div className={styles.newsletterpromoinner}>
					<div className={styles.textarea}>
						<div className={styles.textwrapper}>
							{jumpLinksTitle ? (
								<h2
									data-jumplinkstitle={jumpLinksTitle}
									className={styles.title}
								>
									{title}
								</h2>
							) : (
								<h2 className={styles.title}>{title}</h2>
							)}
							<div
								// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
								dangerouslySetInnerHTML={{
									__html: body,
								}}
							/>
						</div>
						<div className={styles.buttonwrapper}>
							<Button url={buttonUrl} variant="secondary">
								{buttonText}
							</Button>
						</div>
					</div>
					<div className={styles.bordersection}>
						<FuzzyBorder fill={Colours.WHITE} className={styles.borderbottom} />
					</div>
				</div>
				<div className={styles.logoarea}>
					<div className={styles.imagecontainer}>
						<img
							src={
								process.env.GATSBY_IS_IE === "true"
									? wagDogMobileIe
									: wagDogMobile
							}
							alt="Wag - For Dog Lovers"
							loading={"lazy"}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

const DesktopNewsLetterPromo: React.FC<NewsLetterProps> = ({
	title,
	body,
	buttonText,
	buttonUrl,
	jumpLinksTitle,
}) => {
	return (
		<div className={styles.newsletterdesktop}>
			<div className={styles.newsletterpromoouter}>
				<div className={styles.newsletterpromoinner}>
					<div className={styles.textarea}>
						<div className={styles.textwrapper}>
							{jumpLinksTitle ? (
								<h2
									data-jumplinkstitle={jumpLinksTitle}
									className={styles.title}
								>
									{title}
								</h2>
							) : (
								<h2 className={styles.title}>{title}</h2>
							)}
							<div
								// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
								dangerouslySetInnerHTML={{
									__html: body,
								}}
							/>
							<Button url={buttonUrl} variant="secondary">
								{buttonText}
							</Button>
						</div>
					</div>
					<div className={styles.logoarea}>
						<div className={styles.imagecontainer}>
							<img
								src={
									process.env.GATSBY_IS_IE === "true"
										? wagDogDesktopIe
										: wagDogDesktop
								}
								alt="Wag - For Dog Lovers"
								loading={"lazy"}
							/>
						</div>
					</div>
				</div>
				<div className={styles.bordersection}>
					<FuzzyBorder className={styles.borderbottom} fill={Colours.WHITE} />
				</div>
			</div>
		</div>
	);
};

export const SectionHelpAdviceNewsletterPromo: React.FC<NewsLetterProps> = ({
	...props
}) => {
	const windowWidth = useWindowWidth();

	return windowWidth < 1024 ? (
		<MobileNewsLetterPromo {...props} />
	) : (
		<DesktopNewsLetterPromo {...props} />
	);
};

export default SectionHelpAdviceNewsletterPromo;
